import script from "./login-div.vue?vue&type=script&setup=true&lang=js"
export * from "./login-div.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__